import React, {
  useState,
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Dashborad/client.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Button } from "react-bootstrap";
import SummaryComponent from "./SummaryComponent";
import { documentView } from "../../config/service";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import { formatDate } from "../../utils/function";
import { Network } from "../../config/axios";
import { RotatingLines } from "react-loader-spinner";

// Custom FloatingFilterComponent with search button
class CustomFloatingFilter extends React.Component {
  constructor(props) {
    super(props);
    // Initialize with value from columnSearchRef if available
    const initialValue = props.columnSearchRef?.current?.[props.field] || props.currentValue || "";
    this.state = {
      value: initialValue
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
  }

  componentDidMount() {
    // Update state from columnSearchRef after mount
    if (this.props.columnSearchRef?.current?.[this.props.field]) {
      this.setState({ value: this.props.columnSearchRef.current[this.props.field] });
    }
  }

  componentDidUpdate(prevProps) {
    // Update state when searchNonce changes (like in User.jsx)
    if (prevProps.searchNonce !== this.props.searchNonce) {
      const newValue = this.props.columnSearchRef?.current?.[this.props.field] || "";
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
      }
    }
    // Update state if columnSearchRef value changed externally
    if (prevProps.columnSearchRef?.current?.[this.props.field] !==
      this.props.columnSearchRef?.current?.[this.props.field]) {
      const newValue = this.props.columnSearchRef?.current?.[this.props.field] || "";
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
      }
    }
    // Also check if originalSearchValue changed (after data reload)
    if (prevProps.originalSearchValue !== this.props.originalSearchValue && this.props.originalSearchValue) {
      if (this.props.originalSearchValue !== this.state.value) {
        this.setState({ value: this.props.originalSearchValue });
        // Update columnSearchRef to match
        if (this.props.columnSearchRef) {
          this.props.columnSearchRef.current[this.props.field] = this.props.originalSearchValue;
        }
      }
    }
  } 

  onInputChange(e) {
    const newValue = e.target.value;
    this.setState({ value: newValue });
    // Update parent's columnSearchRef
    if (this.props.columnSearchRef) {
      this.props.columnSearchRef.current[this.props.field] = newValue;
    }
    // Trigger AG-Grid filter change
    this.props.onFloatingFilterChanged({
      model: {
        filter: newValue,
        filterType: 'text'
      }
    });
  }

  onSearchClick() {
    // If onSearchClick is provided, use it (immediate search on button click)
    if (this.props.onSearchClick) {
      const searchValue = this.props.columnSearchRef?.current?.[this.props.field] || "";
      this.props.onSearchClick({
        Name: searchValue,
        ID: searchValue,
        Age: searchValue
      });
    } else if (this.props.onSearch) {
      // Fallback to onSearch if onSearchClick is not provided
      this.props.onSearch({ ...this.props.columnSearchRef.current });
    }
  }

  onKeyPress(e) {
    if (e.key === 'Enter') {
      this.onSearchClick();
    }
  }

  onClearClick() {
    // Clear local value
    this.setState({ value: "" });
    // Clear parent's columnSearchRef
    if (this.props.columnSearchRef) {
      this.props.columnSearchRef.current[this.props.field] = "";
    }
    // Clear AG-Grid filter model
    this.props.onFloatingFilterChanged({
      model: {
        filter: "",
        filterType: 'text'
      }
    });
    // Trigger server-side search with empty value (reset results)
    if (this.props.onSearchClick) {
      this.props.onSearchClick({
        Name: "",
        ID: "",
        Age: ""
      });
    } else if (this.props.onSearch) {
      this.props.onSearch({ ...this.props.columnSearchRef.current });
    }
  }

  render() {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", padding: "0 4px" }}>
        <div style={{ position: "relative", flex: 1 }}>
          <input
            type="text"
            value={this.state.value}
            placeholder={this.props.lang === "HE" ? "חיפוש..." : "Search..."}
            onChange={this.onInputChange}
            onKeyPress={this.onKeyPress}
            style={{
              width: "100%",
              padding: "4px 20px 4px 0px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              minWidth: 0
            }}
          />
          <button
            type="button"
            onClick={this.onClearClick}
            style={{
              position: "absolute",
              right: "4px",
              top: "50%",
              transform: "translateY(-50%)",
              padding: "0 4px",
              backgroundColor: "transparent",
              color: "#999",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              lineHeight: "1"
            }}
          >
            ×
          </button>
        </div>
        <button
          onClick={this.onSearchClick}
          style={{
            padding: "4px 10px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            whiteSpace: "nowrap",
            fontSize: "12px"
          }}
        >
          🔍
        </button>
      </div>
    );
  }
}

function useIsButtonDisabled(scheduledDate) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    const oneDayLater = new Date(
      new Date(scheduledDate).getTime() + 24 * 60 * 60 * 1000
    );

    const nowUTC = new Date().toISOString();

    if (new Date(nowUTC) >= oneDayLater) {
      setIsButtonDisabled(true);
    }
    const interval = setInterval(() => {
      const currentTimeUTC = new Date().toISOString();
      if (new Date(currentTimeUTC) >= oneDayLater) {
        setIsButtonDisabled(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [scheduledDate]);

  return isButtonDisabled;
}

const DoctorRX = (props) => {
  const { onlyRx, loader, onSearchUpdate, onSearchClick, originalSearchValue } = props;
  const wrapperRef = useRef(null);
  const gridRef = useRef(null);
  const [meeting, setMeeting] = useState([]);
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [currentUserData, setCurrentUserData] = useState();
  const [doctorData, setDoctorData] = useState();
  const screenWidth = window.innerWidth;
  const [screenSize, setScreenSize] = useState(screenWidth);
  const [summaryId, setSummaryId] = useState();
  const [updateSummaryResponce, setUpdateSummaryResponse] = useState({});
  const [prescriptionResponce, setUpdateProscriptionResponse] = useState([]);
  const [userName, setUserName] = useState("");
  const [checkIDF, setCheckIDF] = useState("");
  const [hasMeetingType, setHasMeetingType] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [isSyrup, setIsSyrup] = useState([]);
  const [meetingType, setMeetingType] = useState("");

  // Search fields initialization - same as User.jsx
  const initialSearchFields = {
    "Patients Details": "",
  };

  const columnSearchRef = useRef({ ...initialSearchFields });
  const [searchNonce, setSearchNonce] = useState(0);

  const handleSearchUpdate = useCallback((updatedSearch) => {
    columnSearchRef.current = { ...columnSearchRef.current, ...updatedSearch };
    setSearchNonce((n) => n + 1);
    if (onSearchUpdate) {
      const searchValue = columnSearchRef.current["Patients Details"] || "";
      onSearchUpdate({
        Name: searchValue,
        ID: searchValue,
        Age: searchValue
      });
    }
  }, [onSearchUpdate]);


  useEffect(() => {
    setScreenSize(screenWidth);
  }, [screenWidth]);

  const handleMobileAction = (data, event) => {
    const buttonRect = event.target.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const dropdownHeight = 120;
    const adjustedTop =
      buttonRect.bottom + dropdownHeight > viewportHeight
        ? buttonRect.top - dropdownHeight
        : buttonRect.bottom;

    if (onlyRx) {
      setPosition({
        top: adjustedTop + window.scrollY,
        left: buttonRect.left + window.scrollX,
      });
    }
    else {
      setPosition({
        top: adjustedTop + window.scrollY - 200,
        left: buttonRect.left + window.scrollX,
      });
    }

    setModalData(data);
    setModal(true);
  };

  const columnDefs = useMemo(() => {
    return [
      {
        headerName: t("Patients Details"),
        field: "Patients Details",
        sortable: true,
        filter: "agTextColumnFilter",
        resizable: true,
        floatingFilter: true,
        floatingFilterComponent: CustomFloatingFilter,
        floatingFilterComponentParams: {
          columnSearchRef: columnSearchRef,
          field: "Patients Details",
          onSearch: handleSearchUpdate,
          onSearchClick: onSearchClick,
          originalSearchValue: originalSearchValue,
          searchNonce: searchNonce,
          lang: lang,
        },
        filterParams: {
          suppressAndOrCondition: true,
          buttons: [],
        },
        width:
          screenSize >= 991
            ? "unset"
            : screenSize <= 991
              ? 140
              : "auto",
        cellRendererFramework: (params) => {
          const patientName = params.value.split(", ")[0];
          const patientDetails = params.value.split(", ").slice(1).join(", ");

          return (
            <div
              className="name-grid"
              dir={"ltr"}
              style={{ justifyContent: lang === "HE" ? "flex-end" : "unset" }}
            >
              <h6>{patientName}</h6> <span>,</span>
              <p>{patientDetails}</p>
            </div>
          );
        },
      },
      {
        headerName: t("Created Date"),
        field: "Created Date",
        sortable: true,
        resizable: true,
        floatingFilter: true,
        sort: "desc",
        valueFormatter: (params) => {
          return params.value
            ? moment(params.value).format("DD-MM-YYYY h:mm:ss a")
            : "";
        },
        width:
          screenSize >= 991
            ? "unset"
            : screenSize <= 991
              ? "auto"
              : "auto",
        flex: screenSize <= 991 && 1,
        cellRendererFramework: (params) => {
          return (
            <div className="date-grid">
              <p>{formatDate(params.value)}</p>
            </div>
          );
        },
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: function (filterLocalDate, cellValue) {
            filterLocalDate = new Date(filterLocalDate);
            cellValue = new Date(new Date(cellValue).setHours(0, 0, 0, 0));
            const filterBy = filterLocalDate.getTime();
            const filterMe = cellValue.getTime();
            if (filterBy === filterMe) return 0;
            return filterMe < filterBy ? -1 : 1;
          },
        },
      },
      {
        headerName: "",
        flex:
          screenSize >= 767
            ? 1
            : "unset",
        width:
          screenSize >= 767
            ? "unset"
            : screenSize <= 991
              ? 50
              : 450,
        cellRendererFramework: (params) => {
          const isButtonDisabled = useIsButtonDisabled(
            params?.data?.meetingDetail?.scheduledDate
          );
          return (
            <>
              <div className="action-grid align-items-center h-100">
                <ActionButtonGrid
                  t={t}
                  data={params?.data}
                  summaryModal={summaryModal}
                  isButtonDisabled={isButtonDisabled}
                  handleFollowupSummary={handleFollowupSummary}
                  viewPdf={viewPdf}
                />
              </div>
              <div className="dropdown-action">
                <Button onClick={(e) => handleMobileAction(params?.data, e)}>
                  {" "}
                  <MoreVertIcon />
                </Button>
              </div>
            </>
          );
        },
      },
    ];
  }, [onlyRx, t, screenSize, lang, handleSearchUpdate, searchNonce]);
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const getallmeetings = () => {
    const filteredAppointmet = props.allAppointment.filter(
      (el) => el.meetingType === "PrescriptionOnly"
    );

    const meetingData = filteredAppointmet.map((d) => {
      return {
        "Created Date": new Date(d.createdAt),
        meetingDetail: d,
        "Patients Details": `${d.patientDetails?.first_name ? d?.patientDetails?.first_name : ""
          } ${d?.patientDetails?.last_name ? d?.patientDetails?.last_name : ""
          }, ${d?.userDetails?.clientDOB
            ? ageCalculator(d?.userDetails?.clientDOB)
            : "N/A"
          }, ${d?.patientDetails?.patientGender}`,
        // Store separate fields for search
        Name: `${d.patientDetails?.first_name ? d?.patientDetails?.first_name : ""
          } ${d?.patientDetails?.last_name ? d?.patientDetails?.last_name : ""
          }`.trim(),
        ID: d?.userDetails?.id || "",
        Age: d?.userDetails?.clientDOB
          ? ageCalculator(d?.userDetails?.clientDOB).toString()
          : "",
        Gender: `${d?.patientDetails?.patientGender}`,
      };
    });
    setMeeting(meetingData);
  };

  useEffect(() => {
    getallmeetings();
    // Restore search text in floating filter via ref + searchNonce (GridApi.getColumn is not public in ag-grid v28)
    const savedValue = originalSearchValue || columnSearchRef.current["Patients Details"] || "";
    let timer;
    if (savedValue) {
      columnSearchRef.current["Patients Details"] = savedValue;
      timer = setTimeout(() => {
        setSearchNonce((n) => n + 1);
      }, 300);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [props.allAppointment, originalSearchValue]);

  // When originalSearchValue changes, sync floating filter input (CustomFloatingFilter reads ref on searchNonce)
  useEffect(() => {
    if (!originalSearchValue) return;
    columnSearchRef.current["Patients Details"] = originalSearchValue;
    const timer = setTimeout(() => {
      setSearchNonce((n) => n + 1);
    }, 100);
    return () => clearTimeout(timer);
  }, [originalSearchValue]);

  // Update search input after loader finishes (when response comes back) - like in User.jsx
  useEffect(() => {
    if (!loader && originalSearchValue) {
      // Update columnSearchRef with the original search value
      columnSearchRef.current["Patients Details"] = originalSearchValue;
      // Trigger searchNonce update to refresh the search input (like in User.jsx)
      setSearchNonce((n) => n + 1);
    }
  }, [loader, originalSearchValue]);

  const summaryModal = (e, id, prescription, summary, data) => {
    e.preventDefault();
    fetchMedicationsByPrescription(prescription)
    setUserName(
      `${data?.userDetails?.first_name}  ${data?.userDetails?.last_name}`
    );
    setCurrentUserData(data?.userDetails);
    setDoctorData(data?.doctorDetails);
    setCheckIDF(data?.consultation[0]?.meetingGroupId);
    setSummaryId(id);
    setUpdateSummaryResponse(summary);
    setUpdateProscriptionResponse(prescription);
    setHasMeetingType(
      Object.prototype.hasOwnProperty.call(data, "meetingType")
    );
    setMeetingType(data?.meetingType)
    props.setOpen(true);
  };


  const fetchMedicationsByPrescription = async (prescriptionArray) => {
    if (!Array.isArray(prescriptionArray) || prescriptionArray.length === 0) {
      console.log("No prescriptions to process.");
      return;
    }
    try {
      const responses = await Promise.all(
        prescriptionArray.map((prescription) =>
          Network().get(
            "/doctor/medicationsById/" + prescription.medicationId,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: token,
              },
            }
          )
        )
      );

      const medicationResults = responses.map((response) => response.data);

      const syrupFlags = medicationResults.map(
        (item) => item?.medication?.ItemForm?.trim() === "SYR"
      );

      setIsSyrup(syrupFlags);

      return medicationResults;
    } catch (error) {
      console.error("Error fetching medications:", error);
    }
  };

  const handleFollowupSummary = (e, data) => {
    e.preventDefault();
    navigate("/create-prescription", { state: { meetingDetail: data } });
  };
  const viewPdf = (document) => {
    document.forEach(async (element) => {
      if (element.type == "Summary" && element.docType === "current") {
        const data = {
          url: element.path,
        };
        const response = await documentView(data);
        setTimeout(() => {
          window.open(response.data, "_blank");
        });
      }
    });
  };

  function ageCalculator(d) {
    var birthDate = new Date(d);
    var otherDate = new Date();

    var years = otherDate.getFullYear() - birthDate.getFullYear();

    if (
      otherDate.getMonth() < birthDate.getMonth() ||
      (otherDate.getMonth() == birthDate.getMonth() &&
        otherDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }
    return years;
  }
  const handleCloseSumm = () => {
    props.handleCloseSummary();
    setUpdateSummaryResponse({});
  };

  const rowHeight = useMemo(() => {
    if (screenSize <= 991) {
      return 60;
    }
    if (onlyRx) {
      return 50;
    }
    return "default";
  }, [onlyRx, screenSize]);

  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setModal(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div className="rx-doctor">
      <SummaryComponent
        open={props.open}
        updateSummaryResponce={updateSummaryResponce}
        setUpdateSummaryResponse={setUpdateSummaryResponse}
        prescriptionResponce={prescriptionResponce}
        setOpen={props.setOpen}
        meetingId={summaryId}
        handleClose={handleCloseSumm}
        AllApoinmentDoctor={props.AllApoinmentDoctor}
        setMeetingValue={props.setMeetingValue}
        meetingValue={props.meetingValue}
        userName={userName}
        checkIDF={checkIDF}
        userData={currentUserData}
        doctorData={doctorData}
        hasMeetingType={hasMeetingType}
        isSyrup={isSyrup}
        setIsSyrup={setIsSyrup}
        meetingType={meetingType}
        usesYarpaProvider={props.usesYarpaProvider}
      />

      <section className="userWrapper doctor-user">
        <div className="adminDataTable">
          <div className="container">
            {onlyRx && (
              <div className="table-title">
                <h2 style={{ textAlign: lang === "HE" ? "right" : "left" }}>
                  {" "}
                  {t("Prescriptions List")}{" "}
                </h2>
              </div>
            )}
            {modal && (
              <MobileAction
                modalData={modalData}
                position={position}
                t={t}
                summaryModal={summaryModal}
                handleFollowupSummary={handleFollowupSummary}
                viewPdf={viewPdf}
                wrapperRef={wrapperRef}
              />
            )}
            {loader ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '50px',
                minHeight: '300px'
              }}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="48"
                  visible={loader}
                />
              </div>
            ) : (
              <div
                className="ag-theme-alpine"
                style={{
                  width: "100%",
                  height: onlyRx ? "calc(100vh - 200px)" : 450,
                  borderRadius: "12px",
                }}
              >
                <AgGridReact
                  ref={gridRef}
                  key={lang}
                  rowData={meeting}
                  columnDefs={columnDefs}
                  animateRows={true}
                  rowSelection="multiple"
                  onCellClicked={cellClickedListener}
                  alwaysShowHorizontalScroll={true}
                  alwaysShowVerticalScroll={true}
                  enableRtl={lang === "HE"}
                  rowHeight={rowHeight}
                  onFilterChanged={(params) => {
                    // Remove only the patient-column grid filter (rows stay unfiltered locally; search is server-side).
                    // Clearing the entire model used to wipe the "Created Date" filter UI/value as well.
                    setTimeout(() => {
                      if (!params.api) return;
                      const model = params.api.getFilterModel() || {};
                      if (!model["Patients Details"]) return;
                      const next = { ...model };
                      delete next["Patients Details"];
                      params.api.setFilterModel(next);
                    }, 0);
                  }}
                  doesExternalFilterPass={() => {
                    return true;
                  }}
                  isExternalFilterPresent={() => {
                    return false;
                  }}
                />
              </div>
            )}
            <div className="add-new-rx">
              <Link to="/create-prescription">
                <AddIcon />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default DoctorRX;

const ActionButtonGrid = ({
  data,
  t,
  handleFollowupSummary,
  viewPdf,
  summaryModal,
  isButtonDisabled,
}) => {
  const { meetingDetail } = data || {};

  return (
    <>
      <Button
        onClick={(e) =>
          summaryModal(
            e,
            meetingDetail?._id,
            meetingDetail?.prescription,
            meetingDetail?.summary,
            meetingDetail
          )
        }
        disabled={isButtonDisabled}
      >
        {t("update")}
      </Button>

      <Button
        onClick={(e) => handleFollowupSummary(e, meetingDetail)}
        style={{ margin: "0px 12px" }}
      >
        {t("Follow up summary")}
      </Button>

      <Button
        onClick={() =>
          viewPdf(
            meetingDetail?.documents?.length ? meetingDetail?.documents : ""
          )
        }
      >
        {t("download")}
      </Button>
    </>
  );
};

const MobileAction = ({
  modalData,
  position,
  t,
  summaryModal,
  handleFollowupSummary,
  viewPdf,
  wrapperRef,
}) => {
  const isButtonDisabled = useIsButtonDisabled(
    modalData?.meetingDetail?.scheduledDate
  );
  return (
    <ul
      className="mobile-action-menu"
      style={{
        position: "absolute",
        top: `${position.top - 80}px`,
        left: `${position.left - 20}px`,
        background: "#fff",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        zIndex: 1000,
        listStyle: "none",
      }}
      ref={wrapperRef}
    >
      <ActionButtonGrid
        t={t}
        data={modalData}
        summaryModal={summaryModal}
        isButtonDisabled={isButtonDisabled}
        handleFollowupSummary={handleFollowupSummary}
        viewPdf={viewPdf}
      />
    </ul>
  );
};
